import React from "react";
import * as S from "./styles";

const AccountSectionHeader = ({ children }) => {
  return <S.Wrapper>{children}</S.Wrapper>;
};

export default AccountSectionHeader;
